/**
 * @description: 优化目标
 * @return {*}
 */
export const OPT_GOAL = {
  APP_ACTIVATE: 'OPTIMIZATIONGOAL_APP_ACTIVATE',
  // ECOMMERCE_ORDER: 'OPTIMIZATIONGOAL_ECOMMERCE_ORDER',
  FIRST_PURCHASE: 'OPTIMIZATIONGOAL_FIRST_PURCHASE',
  APP_PURCHASE: 'OPTIMIZATIONGOAL_APP_PURCHASE',
  APP_REGISTER: 'OPTIMIZATIONGOAL_APP_REGISTER',
  BACK_FLOW: 'OPTIMIZATIONGOAL_BACK_FLOW',
  ONE_DAY_RETENTION: 'OPTIMIZATIONGOAL_ONE_DAY_RETENTION',

  ONE_DAY_PURCHASE_ROAS: 'GOAL_1DAY_PURCHASE_ROAS',
  SEVEN_DAY_PURCHASE_ROAS: 'GOAL_7DAY_PURCHASE_ROAS',
  THIRTY_DAY_PURCHASE_ROAS: 'GOAL_30DAY_PURCHASE_ROAS',
  ONE_DAY_PURCHASE_MONETIZATION_ROAS: 'GOAL_1DAY_PURCHASE_MONETIZATION_ROAS',
  ONE_DAY_MONETIZATION_ROAS: 'GOAL_1DAY_MONETIZATION_ROAS',
  SEVEN_DAY_MONETIZATION_ROAS: 'GOAL_7DAY_MONETIZATION_ROAS',
  THIRTY_DAY_MONETIZATION_ROAS: 'GOAL_30DAY_MONETIZATION_ROAS',

  OPTIMIZATIONGOAL_PAGE_RESERVATION: 'OPTIMIZATIONGOAL_PAGE_RESERVATION',
  OPTIMIZATIONGOAL_CANVAS_CLICK: 'OPTIMIZATIONGOAL_CANVAS_CLICK'
}

/**
 * @description: 深度行为优化目标
 * @return {*}
 */
export const OPT_BEHAVIOR_GOAL_LIST = [
  // {
  //   label: '下单',
  //   value: OPT_GOAL.ECOMMERCE_ORDER
  // },
  {
    label: '首次付费',
    value: OPT_GOAL.FIRST_PURCHASE
  },
  {
    label: '付费次数',
    value: OPT_GOAL.APP_PURCHASE
  },
  {
    label: '注册',
    value: OPT_GOAL.APP_REGISTER
  },
  {
    label: '沉默唤起',
    value: OPT_GOAL.BACK_FLOW
  },
  {
    label: '次日留存',
    value: OPT_GOAL.ONE_DAY_RETENTION
  },
  {
    label: '预约表单',
    value: OPT_GOAL.OPTIMIZATIONGOAL_PAGE_RESERVATION
  },
  {
    label: '预约跳转点击',
    value: OPT_GOAL.OPTIMIZATIONGOAL_CANVAS_CLICK
  }
]

/**
 * @description: 深度ROI优化目标
 * @return {*}
 */
export const OPT_ROI_GOAL_LIST = [
  {
    label: '首日付费ROI',
    value: OPT_GOAL.ONE_DAY_PURCHASE_ROAS
  },
  {
    label: '7日付费ROI',
    value: OPT_GOAL.SEVEN_DAY_PURCHASE_ROAS
  },
  {
    label: '首日变现ROI',
    value: OPT_GOAL.ONE_DAY_MONETIZATION_ROAS
  },
  {
    label: '七日变现ROI',
    value: OPT_GOAL.SEVEN_DAY_MONETIZATION_ROAS
  },
  {
    label: '30天变现ROI',
    value: OPT_GOAL.THIRTY_DAY_MONETIZATION_ROAS
  }
]

/**
 * @description: 智投投放目标枚举smart_delivery_goal
 * @return {*}
 */
export const SMART_DELIVERY_GOAL = {
  // 小游戏
  FIRST_DAY_PURCHASE_ROI: 'SMART_DELIVERY_GOAL_MINI_GAME_FIRST_DAY_PURCHASE_ROI',
  SEVEN_DAY_PURCHASE_ROI: 'SMART_DELIVERY_GOAL_SEVEN_DAY_PURCHASE',
  IAAP_MIX_IN_ONE: 'SMART_DELIVERY_GOAL_IAAP_MIX_IN_ONE',
  DAY30_PURCHASE: 'SMART_DELIVERY_GOAL_DAY30_PURCHASE',
  BACK_FLOW_1DAY_PURCHASE_ROAS: 'SMART_DELIVERY_GOAL_BACK_FLOW_1DAY_PURCHASE_ROAS',
  // app
  GAME_APP_ACTIVATE_ROI_1DAY: 'SMART_DELIVERY_GOAL_GAME_APP_ACTIVATE_ROI_1DAY',
  ACTIVATE: 'SMART_DELIVERY_GOAL_ACTIVATE',
  APP_PURCHASE: 'SMART_DELIVERY_GOAL_APP_PURCHASE',
  FIRST_PURCHASE: 'SMART_DELIVERY_GOAL_FIRST_PURCHASE',
  // 变现ROI 系列（小游戏智投 smart_delivery_goal），值即 deep_conversion_worth_spec.goal
  FIRST_DAY_MONETIZATION: 'SMART_DELIVERY_GOAL_FIRST_DAY_MONETIZATION',
  SEVEN_DAY_MONETIZATION: 'SMART_DELIVERY_GOAL_SEVEN_DAY_MONETIZATION',
  APP_REGISTER_30DAY_MONETIZATION_ROAS: 'SMART_DELIVERY_GOAL_APP_REGISTER_30DAY_MONETIZATION_ROAS'
}

export const SMART_DELIVERY_GOAL_LIST = [
  {
    label: '7日付费ROI',
    value: SMART_DELIVERY_GOAL.SEVEN_DAY_PURCHASE_ROI
  },
  {
    label: '首日付费ROI',
    value: SMART_DELIVERY_GOAL.FIRST_DAY_PURCHASE_ROI
  },
  {
    label: '30付费ROI',
    value: SMART_DELIVERY_GOAL.DAY30_PURCHASE
  },
  {
    label: '混变ROI',
    value: SMART_DELIVERY_GOAL.IAAP_MIX_IN_ONE
  },
  {
    label: '沉默唤起+首日付费ROI',
    value: SMART_DELIVERY_GOAL.BACK_FLOW_1DAY_PURCHASE_ROAS
  },
  {
    label: '首日变现ROI',
    value: SMART_DELIVERY_GOAL.FIRST_DAY_MONETIZATION
  },
  {
    label: '七日变现ROI',
    value: SMART_DELIVERY_GOAL.SEVEN_DAY_MONETIZATION
  },
  {
    label: '30天变现ROI',
    value: SMART_DELIVERY_GOAL.APP_REGISTER_30DAY_MONETIZATION_ROAS
  }
]

export const SMART_DELIVERY_GOAL_APP_LIST = [
  {
    label: '激活和首日付费ROI',
    value: SMART_DELIVERY_GOAL.GAME_APP_ACTIVATE_ROI_1DAY
  },
  {
    label: '激活',
    value: SMART_DELIVERY_GOAL.ACTIVATE
  },
  {
    label: '付费次数',
    value: SMART_DELIVERY_GOAL.APP_PURCHASE
  },
  {
    label: '首次付费',
    value: SMART_DELIVERY_GOAL.FIRST_PURCHASE
  }

]

/**
 * @description: 常用优化目标 = 激活 + 深度行为目标
 * @return {*}
 */
export const OPT_GOAL_LIST = [
  {
    label: '激活',
    value: OPT_GOAL.APP_ACTIVATE
  }
].concat(OPT_BEHAVIOR_GOAL_LIST)

/**
 * @description: 出价方式
 * @return {*}
 */
const BID_MODE = {
  OCPM: 'BID_MODE_OCPM',
  OCPC: 'BID_MODE_OCPC'
}

/**
 * @description: 出价策略
 * @return {*}
 */
const BID_STRATEGY = {
  TARGET_COST: 'BID_STRATEGY_TARGET_COST',
  AVERAGE_COST: 'BID_STRATEGY_AVERAGE_COST',
  PRIORITY_LOW_COST: 'BID_STRATEGY_PRIORITY_LOW_COST'
}

/**
 * @description: 投放场景
 * @return {*}
 */
export const BID_SCENE = {
  NORMAL_AVERAGE: 'BID_SCENE_NORMAL_AVERAGE', // 常规投放-稳定投放
  NORMAL_TARGET: 'BID_SCENE_NORMAL_TARGET', // 常规投放-放量投放
  NORMAL_MAX: 'BID_SCENE_NORMAL_MAX'
}

/**
 * @description: 投放场景
 * @return {*}
 */
export const SMART_BID_TYPE = {
  CUSTOM: 'SMART_BID_TYPE_CUSTOM',
  SYSTEMATIC: 'SMART_BID_TYPE_SYSTEMATIC'
}

/**
 * @description: 深度转化类型
 * @return {*}
 */
export const DEEP_CONVERSION_TYPE = {
  BEHAVIOR: 'DEEP_CONVERSION_BEHAVIOR',
  WORTH: 'DEEP_CONVERSION_WORTH'
}

/**
 * @description: 创建转化类型
 * @return {*}
 */
export const ACCESS_TYPE = {
  SDK: 'ACCESS_TYPE_SDK',
  API: 'ACCESS_TYPE_API'
}

/**
 * @description: 成本控制
 * @return {*}
 */
export const COST_CONTROL = {
  OPEN: 'COST_CONSTRAINT_SCENE_OPEN',
  CLOSE: 'COST_CONSTRAINT_SCENE_CLOSE'
}

export const ACCESS_TYPE_LIST = [
  {
    label: 'SDK转化',
    value: ACCESS_TYPE.SDK
  },
  {
    label: 'API转化',
    value: ACCESS_TYPE.API
  }
]

/**
 * @description: 搜索扩量开关，ADX 程序化广告不可填写提交
 * @return {*}
 */
export const SEARCH_EXPANSION_SWITCH = {
  OPEN: 'SEARCH_EXPANSION_SWITCH_OPEN',
  CLOSE: 'SEARCH_EXPANSION_SWITCH_CLOSE'
}

/**
 * @description: 搜索定向拓展开关，ADX 程序化广告不可填写提交
 * @return {*}
 */
export const SEARCH_EXPAND_TARGETING_SWITCH = {
  OPEN: 'SEARCH_EXPAND_TARGETING_SWITCH_OPEN',
  CLOSE: 'SEARCH_EXPAND_TARGETING_SWITCH_CLOSE'
}

export default {
  BID_SCENE,
  SMART_BID_TYPE,
  OPT_GOAL: Object.freeze(OPT_GOAL),
  OPT_GOAL_LIST: Object.freeze(OPT_GOAL_LIST),
  OPT_ROI_GOAL_LIST: Object.freeze(OPT_ROI_GOAL_LIST),
  BID_MODE: Object.freeze(BID_MODE),
  BID_STRATEGY: Object.freeze(BID_STRATEGY),
  DEEP_CONVERSION_TYPE: Object.freeze(DEEP_CONVERSION_TYPE),
  ACCESS_TYPE: Object.freeze(ACCESS_TYPE),
  COST_CONTROL: Object.freeze(COST_CONTROL),
  SEARCH_EXPANSION_SWITCH: Object.freeze(SEARCH_EXPANSION_SWITCH),
  SEARCH_EXPAND_TARGETING_SWITCH: Object.freeze(SEARCH_EXPAND_TARGETING_SWITCH),
  SMART_DELIVERY_GOAL: Object.freeze(SMART_DELIVERY_GOAL),
  SMART_DELIVERY_GOAL_LIST: Object.freeze(SMART_DELIVERY_GOAL_LIST),
  SMART_DELIVERY_GOAL_APP_LIST: Object.freeze(SMART_DELIVERY_GOAL_APP_LIST)
}
